const initialState = {
  services: {},
  loading: false
};

export function fetchServices(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_SERVICES.SUCCESS':
      return {
        ...state,
        services:  action.services.body,
      };
    default:
      return state
  }
}

export function saveServices(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_SERVICES.SUCCESS':
      return {
        ...state,
        services:  action.services.body,
      };
    default:
      return state
  }
}
